export default "__VITE_ASSET__CtPUEmeU__"